// src/context/SocketProvider.tsx

import { io, Socket } from "socket.io-client";

  import { useAuth } from "./AuthContext";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { useOrder } from "./OrderContext";

type LiveDeliveryUpdate = {
  orderId: string;
  newStatus: string;
  trackingUrl?: string;
  eta?: string;
};

interface SocketContextType {
  socket: Socket | null;
  deliveryUpdate: LiveDeliveryUpdate | null;
}

const SocketContext = createContext<SocketContextType>({
  socket: null,
  deliveryUpdate: null,
});

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
 const { user } = useAuth();
 const {setRecentOrder, recentOrder} = useOrder();

 const [socket, setSocket] = useState<Socket | null>(null);
 const [deliveryUpdate, setDeliveryUpdate] =
   useState<LiveDeliveryUpdate | null>(null);

useEffect(() => {
  console.log(`KKKK Ref Order is `, recentOrder)
if(recentOrder){  recentOrder.map((order: any) => {
    if (socket) {
      socket.emit("NEW_ORDER_PLACED", { message: "New order placed", deliveryId : order?.deliveryId });
    }
  });}
}, [recentOrder, socket]);

  useEffect(() => {


    if(!user)
    {
      return ;
    }
    console.log("hello socket", process.env.REACT_APP_URL);
    const newSocket = io(process.env.REACT_APP_URL, {
      transports: ["websocket"],
      reconnection: true,
    });

    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("Socket connected:", newSocket.id);
    });



    newSocket.emit("USER_CONNECTED",{message:"user",user})

    newSocket.on("order_status_update", (data: LiveDeliveryUpdate) => {
      console.log("GLOBAL SOCKET UPDATE:", data);
      setDeliveryUpdate(data);
    });






    newSocket.on("ROOM_JOINED", (data: any) => {
      console.log("ROOM_JOINED:", data);
    });

    return () => {
      newSocket.disconnect();
    };
  }, [user]);


    useEffect(() => {
      console.log(`Socket Order is `,recentOrder)
         if(socket) socket.on("DELIVERY_STATUS_UPDATE", (data: any) => {
      console.log("DELIVERY SOCKET UPDATE:", data, data.deliveryStatus);
      console.log("UPODATE RECENT ORDER",recentOrder);
      setRecentOrder(recentOrder?.map((order: any) => {
        if (order.deliveryId === data.orderId) {
          return { ...order, deliveryStatus: data.deliveryStatus };
        }
        return order;
      }));

      setDeliveryUpdate(data);
    });


    }, [recentOrder, socket]);


  useEffect(() => {
    if ( user) {
      
    console.log("USER SOCKET:", user);
    }
  }, [ user]);

  return (
    <SocketContext.Provider value={{ socket, deliveryUpdate }}>
      {children}
    </SocketContext.Provider>
  );
};
